import React from "react";
import banner from "../../../../assets/new/image.svg";
import { FaWhatsapp } from "react-icons/fa";
import { TbWorld } from "react-icons/tb";

const Hero = () => {
  return (
    <div className="rounded-lg relative w-full sm:w-1/3">
      <img
        src={banner}
        alt="chatbot baaner "
        className="w-full h-full aspect-video"
      />
      <div className="absolute top-[6%] sm:top-[8%] left-[30%] bg-white shadow-[0_4px_8px_rgba(0,0,0,1)] rounded-full p-1 animate-bounces-vertical">
        <FaWhatsapp className="bg-green-400  rounded-full min-w-4 min-h-4 sm:min-w-6 sm:min-h-6 text-white" />
      </div>

      <div className="absolute top-[14%] sm:top-[16%] left-[45%] bg-white  shadow-[0_4px_8px_rgba(0,0,0,1)]  rounded-full p-1 animate-bounces-vertical">
        <TbWorld className="bg-blue-400  rounded-full min-w-4 min-h-4 sm:min-w-6 sm:min-h-6 text-white" />
      </div>
    </div>
  );
};

export default Hero;
